import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type SimilarWorkOrder = ResultOf<
  typeof similarWorkOrdersQuery
>["similarWorkOrders"]["data"][number];

export const similarWorkOrdersQuery = graphql(`
  query SimilarWorkOrders($work_order_id: ID!, $first: Int!) {
    similarWorkOrders(work_order_id: $work_order_id, first: $first, page: 1) {
      data {
        id
        reference
        admin_notes
        vehicle_type
        number_of_drivers
        has_return_trip
        depart_after
        departureAddress {
          city
        }
        deliveryAddress {
          city
        }
        currentQuote {
          id
          currency
          amount_exc_tax
        }
      }
    }
  }
`);
